import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { Button, ItemCardList } from 'components';
import { IComment, IUserMentionsDataItem } from 'models/common';
import { reduxForm, Field } from 'redux-form';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { IPage } from 'models/common';
import { UserMentionInput } from 'components/FormControls/UserMentionInput';
import { getUserCard } from 'redux/modules/user/usercard';
import { IFetchDefault } from 'redux/modules/fetch';
import { IStore } from 'redux/IStore';
import { StarsRating } from 'components/Common/StarsRating';
import { PortalInputField } from 'components/FormControls';
import { formatInteger } from 'helpers/common';
const { connect } = require('react-redux');

require('./style.css');

interface IProps {
	comments?: IComment[];
	commentsPage?: IPage;
	initialValues?: IComment;
	currentFormValues?: IComment;
	scrollableDivNode?: any;
	userId?: string;
	fetchDefault?: IFetchDefault;
	disableMentions?: boolean;
	inputPlaceholder?: string;
	title?: string;
	enableRating?: boolean;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	/* function props */
	t?: (key: string, options?: any) => string;
	onAddComment?: (comment: IComment) => void;
	loadMoreComments?: () => void;
	change: (field: string, value: any) => void;
	getUserCard: (id: string) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AddCommentForm extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.onMentionAdd = this.onMentionAdd.bind(this);
		this.handleOnStarClick = this.handleOnStarClick.bind(this);
	}

	private onSubmit(form: IComment) {
		if (form && form.body && form.body.length > 0) {
			form.data = JSON.stringify(form.dataArray);
			this.props.onAddComment(form);
		}
	}

	private onMentionAdd(id: string, name: string) {
		const dataArray = this.props.currentFormValues.dataArray;
		const userMention: IUserMentionsDataItem = {
			id,
			name,
		};
		dataArray.push(userMention);
		this.props.change('dataArray', dataArray);
	}

	private handleOnStarClick(value: number) {
		this.props.change('rating', value);
	}

	public render() {
		const {
			t,
			comments,
			handleSubmit,
			commentsPage,
			scrollableDivNode,
			userId,
			fetchDefault,
			disableMentions,
			inputPlaceholder,
			title,
			enableRating,
			currentFormValues,
		} = this.props;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: comments.length,
			next: this.props.loadMoreComments,
			hasMore: commentsPage.totalItems > comments.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
			scrollableTarget: scrollableDivNode,
		};

		const listProps: IItemCardList = {
			items: comments,
			itemType: c.NODE_TYPE_COMMENT_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			goToCard: (id: string) => this.props.getUserCard(id),
		};

		let inputField = (
			<>
				<Field
					name={'body'}
					component={UserMentionInput}
					type="text"
					userId={userId}
					onMentionAdd={this.onMentionAdd}
					fetchDefault={fetchDefault}
					label={inputPlaceholder}
				/>
			</>
		);

		if (disableMentions) {
			inputField = (
				<Field
					name={'body'}
					component={PortalInputField}
					type="text"
					label={inputPlaceholder && inputPlaceholder.length > 0 ? inputPlaceholder : t('AddComment_Input_Placeholder')}
				/>
			);
		}

		return (
			<div className="addComment">
				<h4 className="commentTitle">
					{title && title.length ? title : t('AddComment_Title')}{' '}
					<span className="commentCount">({formatInteger(commentsPage.totalItems)})</span>
				</h4>
				{enableRating ? (
					<div>
						<StarsRating
							editing={true}
							onStarClick={this.handleOnStarClick}
							rating={currentFormValues ? currentFormValues.rating : undefined}
						/>
					</div>
				) : null}
				{userId ? (
					<div className="Comments">
						<form onSubmit={handleSubmit(this.onSubmit)}>
							{inputField}
							<Button type="submit">{t('BSPortal_Common_Add')}</Button>
						</form>
						{disableMentions ? null : <div className="descriptionComment">{t('AddComment_MentionDescription')}</div>}
					</div>
				) : null}
				<div className="wrapperComments">
					<ItemCardList {...listProps} />
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: IStore, props: IProps) {
	let currentFormValues: IComment = null;
	if (state.form[c.FORM_NAME_ADD_COMMENT] && state.form[c.FORM_NAME_ADD_COMMENT].values) {
		currentFormValues = state.form[c.FORM_NAME_ADD_COMMENT].values;
	}

	return {
		initialValues: props.initialValues,
		currentFormValues,
		fetchDefault: state.fetchDefault,
	};
}

let AddComment = reduxForm(
	{
		form: c.FORM_NAME_ADD_COMMENT,
		enableReinitialize: false,
	},
	mapStateToProps,
)(AddCommentForm);

AddComment = connect(mapStateToProps, (dispatch) => ({
	dispatch,
	getUserCard: (id: string) => dispatch(getUserCard(id)),
}))(AddComment);

export { AddComment };
